export const CHANGE_PASSWORD_CHANGE_PASSWORD_BEGIN = 'CHANGE_PASSWORD_CHANGE_PASSWORD_BEGIN';
export const CHANGE_PASSWORD_CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_CHANGE_PASSWORD_FAILURE';
export const CHANGE_PASSWORD_CHANGE_PASSWORD_DISMISS_ERROR = 'CHANGE_PASSWORD_CHANGE_PASSWORD_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/change-password/redux/constants.js